<script lang="ts">
	import { formatNumberWithSeparators } from "../../../functions";
	import { ProgrammaComunicazione } from "../../../models/PSCL/Schema/PSCLSchemaProgettazione";

	export let data: ProgrammaComunicazione = new ProgrammaComunicazione();
</script>


<table class="w-full text-xs border border-black table-fixed">
	<thead>
		<tr>
			<th class="border border-black">Misura</th>
			<th class="border border-black">Descrizione</th>
			<th class="border border-black">Costo</th>
			<th class="border border-black">Note</th>
		</tr>
	</thead>
	<tbody>
		{#if data?.misureAzioniComunicazione?.length > 0}
			{#each data.misureAzioniComunicazione as misuraAzioneComunicazione}
				<tr>
					<td class="text-center border border-black" rowspan="{misuraAzioneComunicazione?.azioniComunicazione?.length + 1}">{misuraAzioneComunicazione?.misura}</td>
				</tr>
				{#each misuraAzioneComunicazione?.azioniComunicazione as azioneComunicazione}
					<tr>
						<td class="text-center border border-black">{azioneComunicazione?.descrizione || ''}</td>
						<td class="text-center border border-black">{azioneComunicazione?.costo !== null ?  formatNumberWithSeparators(azioneComunicazione?.costo) + '€' : '-'}</td>
						<td class="text-center border border-black">{azioneComunicazione?.note || ''}</td>
					</tr>
				{/each}
			{/each}
		{:else}
			<td class="text-center bg-blue-100 border border-black">-</td>
			<td class="text-center bg-blue-100 border border-black">-</td>
			<td class="text-center bg-blue-100 border border-black">-</td>
			<td class="text-center bg-blue-100 border border-black">-</td>
		{/if}
	</tbody>
</table>